import { RefreshCw, AlertCircle } from 'lucide-react';
import Modal from './Modal';
import Button from './Button';

interface QRCodeModalProps {
  isOpen: boolean;
  onClose: () => void;
  sessionName: string;
  qrCodeUrl?: string;
  isLoading: boolean;
  error?: string | null;
}

function QRCodeModal({
  isOpen,
  onClose,
  sessionName,
  qrCodeUrl,
  isLoading,
  error,
}: QRCodeModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`QR Code - ${sessionName}`}
      footer={
        <Button type="button" variant="secondary" onClick={onClose} fullWidth>
          Fechar
        </Button>
      }
    >
      <div className="flex justify-center">
        {isLoading ? (
          <div className="flex items-center justify-center">
            <RefreshCw className="h-8 w-8 animate-spin text-primary-600" />
          </div>
        ) : error ? (
          <div className="flex flex-col items-center text-center">
            <AlertCircle className="h-12 w-12 text-yellow-500 mb-2" />
            <p className="text-gray-600">{error}</p>
          </div>
        ) : qrCodeUrl ? (
          <img 
            src={qrCodeUrl} 
            alt="QR Code WhatsApp" 
            className="max-w-full h-auto"
          />
        ) : null}
      </div>
    </Modal>
  );
}

export default QRCodeModal;